import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSessionAuth } from "./auth/SessionAuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import navConfig from "./routes/nav.config.json";
import Layout from "./components/Layout";
import LoadingScreen   from "./components/LoadingScreen";
import Unauthorized from "./pages/Unauthorized";

// Static route fallback component map
import Dashboard from "./pages/Dashboard/Dashboard";
import NewDashboard from "./pages/NewDashboard";
import Profile from "./pages/Profile";
import Preferences from "./pages/Preferences";
import LanguageInfo from "./pages/LanguageInfo";
import EmployeeList from "./pages/Employees/EmployeeList";
import DeviceLogList from "./pages/Reports/DeviceLogList";
import ValidationLogList from "./pages/Reports/ValidationLogList";
import FaceValidationReport from "./pages/Reports/FaceValidationReport";
import ValidationRequirementsReport from "./pages/Reports/ValidationRequirementsReport";
import FailedLoginAttempts  from "./pages/Reports/FailedLoginAttempts";
import LocationMasterList from "./pages/Configuration/LocationMasterList";
import EmployeeProfile from "./pages/Employees/EmployeeProfile"; 
import AssignedLocationList from "./pages/Employees/AssignedLocationList";
import SyncStatusCards from "./pages/Configuration/SyncStatusCards";
import AdminUserAccessList  from "./pages/Configuration/AdminUserAccessList";
import AttendanceLogList from "./pages/Employees/AttendanceLogList";
import DetailedAttendanceLogList from "./pages/Employees/DetailedAttendanceLogList";

const componentMap = {
  Dashboard,
  NewDashboard,
  Profile,
  Preferences,
  LanguageInfo,
  EmployeeList,
  DeviceLogList,
  ValidationLogList,
  FaceValidationReport,
  ValidationRequirementsReport,
  FailedLoginAttempts,
  LocationMasterList,
  EmployeeProfile,
  AssignedLocationList,
  SyncStatusCards,
  AdminUserAccessList,
  AttendanceLogList,
  DetailedAttendanceLogList,
};

const App = () => {
  const { roles , loading} = useSessionAuth();

 
  if (loading || !roles) {
    return <div>Loading App...</div>; // or use a spinner
  }

 

  const isAllowed = (allowedRoles = []) =>
    allowedRoles.length === 0 || allowedRoles.some((role) => roles?.[role]);

  return (
    <Routes>
       {navConfig
  .filter((route) => route.url && route.component && isAllowed(route.allowedRoles))
  .map((route) => {
    const Component = componentMap[route.component];
    const requiresAuth = route.allowedRoles?.length > 0;

    if (!Component) {
      console.warn(`Missing component for route: ${route.component}`);
      return null;
    }

    return (
      <Route
        key={route.url}
        path={route.url}
        element={
          requiresAuth ? (
            <ProtectedRoute allowedRoles={route.allowedRoles}>
              <Layout>
                <Component />
              </Layout>
            </ProtectedRoute>
          ) : (
            <Layout>
              <Component />
            </Layout>
          )
        }
      />
    );
  })} 
      <Route path="/unauthorized" element={<Unauthorized />} /> 
      <Route path="*" element={<Navigate to="/dashboard" />} />
    
    </Routes>
  );
};

export default App;
